// extracted by mini-css-extract-plugin
export default {"periodSelector":"PeriodSelector_periodSelector__DVpYD"};